import { VaultClassTags } from "./VaultClassTag";
import { VaultDocumentTypeTags } from "./VaultDocumentTypeTag";
import { VaultListTagsWrapper, VaultTagEllipsis } from "./VaultListTags.styles"
import { VaultPeriodTag } from "./VaultPeriodTag";
import { useStore } from '../../../app/data/root.store';
import { observer } from 'mobx-react';

export const VaultListTags = observer(({ file }) => {
    const { vaultStore } = useStore();

    const periods = file?.periods?.length ? file.periods.map(p => p.period || p.label || p.key || p) : [];
    const tags = file?.tags || [];
    const linkedAssets = file?.linkedAssets || file?.relatedItems || [];

    const tagsCount = periods.length + tags.length + linkedAssets.length;
    
    if (vaultStore.mainTableWidth < 700 && tagsCount > 0) {
        return (
            <VaultListTagsWrapper>
                <VaultTagEllipsis>{tagsCount} label{tagsCount > 1 ? 's' : ''}</VaultTagEllipsis>
            </VaultListTagsWrapper>
        );
    }

    const minimized = (tagsCount > 3);

    return (
        <VaultListTagsWrapper>
            {
                periods.length > 0 &&
                periods.map((period, index) => (
                    <VaultPeriodTag key={index} period={period} />
                ))
            }
            {
                tags.length > 0 &&
                <VaultDocumentTypeTags tags={tags} minimized={minimized} />
            }
            {
                linkedAssets.length > 0 &&
                <VaultClassTags linkedAssets={linkedAssets} minimized={minimized} />
            }
        </VaultListTagsWrapper>
    )
})